import React from "react"
import { useToggle } from "../../../reactUse"
import { Icon } from "antd"

export default ({ onChangeMenu, current, list }) => {
  var [expand, toggle] = useToggle(false)
  return (
    <div className={"shop-menu" + (expand ? " expand" : "")}>
      <ul>
        <li
          className="til"
          onClick={() => {
            toggle()
          }}
        >
          {current.name}
          <Icon type="down" />
        </li>

        <li className="down-content">
          {list.map((m, i) => {
            let cName = m.className
            return (
              <span
                key={i}
                className={
                  "menu" + (cName === current.className ? " select" : "")
                }
                onClick={() => {
                  onChangeMenu(m)
                  toggle()
                }}
              >
                <i className={`s-icon ${cName}`} />
                <span>{m.name}</span>
              </span>
            )
          })}
        </li>
      </ul>
    </div>
  )
}
